"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AllowedComponentsContainer = exports.AllowedComponentPlaceholderList = exports.AllowedComponentPlaceholder = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _meta = require("../_utils/meta");
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = (0, _getPrototypeOf2.default)(t); if (r) { var s = (0, _getPrototypeOf2.default)(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return (0, _possibleConstructorReturn2.default)(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ALLOWED_PLACEHOLDER_CLASS_NAMES = 'aem-AllowedComponent--list';
var ALLOWED_COMPONENT_TITLE_CLASS_NAMES = 'aem-AllowedComponent--title';
var ALLOWED_COMPONENT_PLACEHOLDER_CLASS_NAMES = 'aem-AllowedComponent--component cq-placeholder placeholder';

/**
 * Placeholder for one Allowed Component
 */
var AllowedComponentPlaceholder = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(AllowedComponentPlaceholder, _Component);
  var _super = _createSuper(AllowedComponentPlaceholder);
  function AllowedComponentPlaceholder() {
    (0, _classCallCheck2.default)(this, AllowedComponentPlaceholder);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(AllowedComponentPlaceholder, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        path = _this$props.path,
        emptyLabel = _this$props.emptyLabel;
      return __jsx("div", {
        "data-cq-data-path": path,
        "data-emptytext": emptyLabel,
        className: ALLOWED_COMPONENT_PLACEHOLDER_CLASS_NAMES
      });
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        emptyLabel: _propTypes.default.string,
        path: _propTypes.default.string
      };
    }
  }]);
  return AllowedComponentPlaceholder;
}(_react.Component);
/**
 * List of placeholder of the Allowed Component Container component
 *
 * @class
 * @extends React.Component
 * @private
 */
exports.AllowedComponentPlaceholder = AllowedComponentPlaceholder;
var AllowedComponentPlaceholderList = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(AllowedComponentPlaceholderList, _Component2);
  var _super2 = _createSuper(AllowedComponentPlaceholderList);
  function AllowedComponentPlaceholderList() {
    (0, _classCallCheck2.default)(this, AllowedComponentPlaceholderList);
    return _super2.apply(this, arguments);
  }
  (0, _createClass2.default)(AllowedComponentPlaceholderList, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        components = _this$props2.components,
        placeholderClassNames = _this$props2.placeholderClassNames,
        title = _this$props2.title,
        emptyLabel = _this$props2.emptyLabel;
      var listLabel = components && components.length > 0 ? title : emptyLabel;
      return __jsx("div", {
        className: ALLOWED_PLACEHOLDER_CLASS_NAMES + ' ' + placeholderClassNames
      }, __jsx("div", {
        "data-text": listLabel,
        className: ALLOWED_COMPONENT_TITLE_CLASS_NAMES
      }), components.map(function (component, i) {
        return __jsx(AllowedComponentPlaceholder, {
          key: i,
          path: component.path,
          emptyLabel: component.title
        });
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        title: _propTypes.default.string,
        emptyLabel: _propTypes.default.string,
        components: _propTypes.default.arrayOf(_propTypes.default.shape({
          path: _propTypes.default.string,
          title: _propTypes.default.string
        })),
        placeholderClassNames: _propTypes.default.string,
        cqPath: _propTypes.default.string
      };
    }
  }]);
  return AllowedComponentPlaceholderList;
}(_react.Component);
/**
 *  When applicable, the component exposes a list of allowed components
 */
exports.AllowedComponentPlaceholderList = AllowedComponentPlaceholderList;
var AllowedComponentsContainer = /*#__PURE__*/function (_Container) {
  (0, _inherits2.default)(AllowedComponentsContainer, _Container);
  var _super3 = _createSuper(AllowedComponentsContainer);
  function AllowedComponentsContainer() {
    (0, _classCallCheck2.default)(this, AllowedComponentsContainer);
    return _super3.apply(this, arguments);
  }
  (0, _createClass2.default)(AllowedComponentsContainer, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        allowedComponents = _this$props3.allowedComponents,
        _allowedComponentPlaceholderListEmptyLabel = _this$props3._allowedComponentPlaceholderListEmptyLabel,
        title = _this$props3.title,
        isInEditor = _this$props3.isInEditor,
        _this$props3$userIsLo = _this$props3.userIsLoggedIn,
        userIsLoggedIn = _this$props3$userIsLo === void 0 ? false : _this$props3$userIsLo,
        authenticatedUserBGColor = _this$props3.authenticatedUserBGColor,
        unauthenticatedUserBGColor = _this$props3.unauthenticatedUserBGColor,
        desktopSpacing = _this$props3.desktopSpacing,
        mobileSpacing = _this$props3.mobileSpacing,
        _this$props3$isMobile = _this$props3.isMobile,
        isMobile = _this$props3$isMobile === void 0 ? false : _this$props3$isMobile;
      var isAemEditMode = (0, _meta.getWcmmode)() === 'edit';
      var isAemPreviewMode = (0, _meta.getWcmmode)() === 'preview' || (0, _meta.getWcmmode)() === 'disabled';
      if (isInEditor && allowedComponents && allowedComponents.applicable) {
        return __jsx(AllowedComponentPlaceholderList, (0, _extends2.default)({
          title: title,
          emptyLabel: _allowedComponentPlaceholderListEmptyLabel,
          components: allowedComponents.components
        }, this.placeholderProps));
      } else if (allowedComponents && allowedComponents.applicable === false) {
        var _this$childComponents;
        var styles = {
          Default: this.containerProps['data-container-bgcolor'],
          paddingValue: this.containerProps['data-container-padding'],
          gridClassName: this.containerProps['data-container-gridclassname'],
          colclassName: this.containerProps['data-container-colclassname'],
          cssClassName: this.containerProps['data-container-cssclassname']
        };
        var desktopSpacingInitialObj = {
          desktopSpacingBottom: '0',
          desktopSpacingLeft: '0',
          desktopSpacingRight: '0',
          desktopSpacingTop: '0'
        };
        var mobileSpacingInitialObj = {
          mobileSpacingBottom: '0',
          mobileSpacingLeft: '0',
          mobileSpacingRight: '0',
          mobileSpacingTop: '0'
        };
        var isNotBgcolorPresent = authenticatedUserBGColor === '' && unauthenticatedUserBGColor === '';
        var _ref = (0, _lodash.isEmpty)(desktopSpacing) ? desktopSpacingInitialObj : desktopSpacing,
          desktopSpacingTop = _ref.desktopSpacingTop,
          desktopSpacingRight = _ref.desktopSpacingRight,
          desktopSpacingBottom = _ref.desktopSpacingBottom,
          desktopSpacingLeft = _ref.desktopSpacingLeft;
        var containerDesktopMargin = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, desktopSpacingTop ? {
          marginTop: "".concat(desktopSpacingTop, "px")
        } : {}), desktopSpacingBottom ? {
          marginBottom: "".concat(desktopSpacingBottom, "px")
        } : {}), isNotBgcolorPresent && desktopSpacingRight ? {
          marginRight: "".concat(desktopSpacingRight, "px")
        } : {}), isNotBgcolorPresent && desktopSpacingLeft ? {
          marginLeft: "".concat(desktopSpacingLeft, "px")
        } : {});
        var _ref2 = (0, _lodash.isEmpty)(mobileSpacing) ? mobileSpacingInitialObj : mobileSpacing,
          mobileSpacingTop = _ref2.mobileSpacingTop,
          mobileSpacingRight = _ref2.mobileSpacingRight,
          mobileSpacingBottom = _ref2.mobileSpacingBottom,
          mobileSpacingLeft = _ref2.mobileSpacingLeft;
        var containerMobileMargin = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mobileSpacingTop ? {
          marginTop: "".concat(mobileSpacingTop, "px")
        } : {}), mobileSpacingBottom ? {
          marginBottom: "".concat(mobileSpacingBottom, "px")
        } : {}), isNotBgcolorPresent && mobileSpacingRight ? {
          marginRight: "".concat(mobileSpacingRight, "px")
        } : {}), isNotBgcolorPresent && mobileSpacingLeft ? {
          marginLeft: "".concat(mobileSpacingLeft, "px")
        } : {});
        var containerMargin = isMobile ? containerMobileMargin : containerDesktopMargin;
        return __jsx(_react.default.Fragment, null, (userIsLoggedIn && this.props.halfGatedContent || isAemEditMode || isAemPreviewMode || !this.props.halfGatedContent) && __jsx("div", (0, _extends2.default)({}, this.containerProps, {
          "aria-label": this.props.accessibilityLabel
        }), __jsx("div", {
          id: this.containerProps['data-container-id'],
          className: "cmp-container ".concat(styles.cssClassName),
          style: containerMargin
        }, isAemEditMode && isInEditor && this.props.halfGatedContent && __jsx("div", {
          className: "cmp-container--hidden"
        }, "This container is configured as Gated content, users will be required to login to see the content."), __jsx("div", {
          className: styles.gridClassName
        }, (_this$childComponents = this.childComponents) === null || _this$childComponents === void 0 ? void 0 : _this$childComponents.map(function (cmp) {
          return cmp;
        }))), this.placeholderComponent, ' '));
      }
      return (0, _get2.default)((0, _getPrototypeOf2.default)(AllowedComponentsContainer.prototype), "render", this).call(this);
    }
  }]);
  return AllowedComponentsContainer;
}(_aemReactEditableComponents.Container);
exports.AllowedComponentsContainer = AllowedComponentsContainer;
AllowedComponentsContainer.defaultProps = {
  // Temporary property until CQ-4265892 is addressed, beware not rely it
  _allowedComponentPlaceholderListEmptyLabel: 'No allowed components'
};